/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_Err_EmailInputs */

const en_st_wl_err_email = /** @type {(inputs: St_Wl_Err_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

const id_st_wl_err_email = /** @type {(inputs: St_Wl_Err_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat email yang valid.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {St_Wl_Err_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_err_email = /** @type {((inputs?: St_Wl_Err_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_Err_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_err_email(inputs)
	return en_st_wl_err_email(inputs)
});